import { axiosInstance } from "./AxiosDefaults";
import { productsRoute } from "../constants/ApiRoutes";
import { Product } from "../models/Product";

export type ApiResponse<T> = {
  status?: "SUCCESS" | "ERROR";
  message?: string;
  result?: T;
};

export const getAllProducts = (): Promise<any> => {
  return axiosInstance.get(productsRoute, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const createProduct = (payload: Partial<Product>): Promise<any> => {
  return axiosInstance.post(productsRoute, payload, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const updateOneProduct = (
  id: string,
  payload: Partial<Product>
): Promise<any> => {
  return axiosInstance.put(`${productsRoute}/${id}`, payload, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const deleteOneProduct = (id: string): Promise<any> => {
  return axiosInstance.delete(`${productsRoute}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};
